// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","502":"MyDeals","594":"about"}[chunkId] || chunkId) + "." + {"53":"b72fdd40","179":"640d0bcb","427":"021c1416","502":"d781a595","563":"c31a61a3","594":"96ce4c8c"}[chunkId] + ".js";
};